import { NgModule } from "@angular/core";
import { Auth0SidebarUserComponent } from "./components/auth0-sidebar/auth0-sidebar-user.component";
import { LgLocalizationModule } from "@logex/framework/lg-localization";
import { PivotSearchComponent } from "./components/pivot-search/pivot-search.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { UiCoreModule } from "@logex/framework/ui-core";
import { SwitchComponent } from "./components/switch-component/switch.component";
import { ModSwitchSliderComponent } from "./components/switch-component/mod-switch-slider.component";
import { TextClipboardCopyComponent } from "./components/text-clipboard-copy/text-clipboard-copy.component";

@NgModule({
    declarations: [
        Auth0SidebarUserComponent,
        PivotSearchComponent,
        SwitchComponent,
        ModSwitchSliderComponent
    ],
    imports: [
        LgLocalizationModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        UiCoreModule,
        TextClipboardCopyComponent
    ],
    exports: [
        Auth0SidebarUserComponent,
        PivotSearchComponent,
        SwitchComponent,
        ModSwitchSliderComponent,
        TextClipboardCopyComponent
    ]
})
export class SharedModule {}
